<template>
  <div class="pc-avatar" :class="[sizeClass, round ? 'round' : '', border ? 'border' : '']" v-if="hasAvatar">
    <img :src="avatar"/>
  </div>
  <div class="pc-avatar" :class="[sizeClass, round ? 'round' : '', border ? 'border' : '']" v-html="defaultAvatar" v-else>
  </div>
</template>

<script>
import { toSvg } from 'jdenticon'
import { isNullOrWhiteSpace } from '@/common/utils'
import { mapGetters } from 'vuex'

export default {
  props: {
    size: {
      type: Number,
      default: 40
    },
    theme: {
      type: String,
      default: 'blue' // white blue
    },
    // img: {
    //   type: String,
    //   default: ''
    // },
    round: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    hasAvatar () {
      return !isNullOrWhiteSpace(this.user.avatar)
    },
    sizeClass () {
      return 'avatar-' + this.size
    },
    defaultAvatar () {
      return toSvg(this.user.email, this.size)
    },
    avatar () {
      return this.user.avatar
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-avatar {
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  overflow: hidden;

  svg {
    max-width: 100%;
    max-height: 100%;
  }

  img {
    max-height: 100%;
    max-width: 100%;
    margin: 0 !important;
  }

  &.avatar-34 {
    width: 3.4rem;
    height: 3.4rem;
  }

  &.avatar-20 {
    width: 2rem;
    height: 2rem;
  }

  &.avatar-40 {
    width: 4rem;
    height: 4rem;
  }

  &.avatar-100 {
    width: 10rem;
    height: 10rem;
  }

  &.avatar-200 {
    width: 20rem;
    height: 20rem;
  }

  &.round {
    border-radius: 50%;
  }

  &.border {
    border: 1px solid $border-color-structure;
  }
}
</style>
